import styled from 'styled-components';
import { FONT_FAMILY, FONTS, COLORS } from 'utils/styles';
import { BREAKPOINTS } from 'admin/utils/breakpoints';

export const SampleDiv = styled.div``;

export const AdminProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  height: auto;
`;

export const AdminProfileSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  min-height: ${({ isUpdatePass }) => (isUpdatePass ? '238px' : '100px')};
  height: auto;
  border-bottom: 1px solid ${COLORS.whiteLite};

  @media only screen and ${BREAKPOINTS.desktop} {
    padding-bottom: 10px;
  }
`;

export const InfoAboutSection = styled.div`
  align-self: ${({ isSectionDescription }) =>
    isSectionDescription ? 'start' : 'unset'};
  margin-top: ${({ isSectionDescription }) =>
    isSectionDescription ? '10px' : 'unset'};
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 350px;
  height: 100px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 200px;
    height: auto;
  }
`;

export const FullSectionTitle = styled.span`
  ${FONTS.font18};
  ${FONT_FAMILY.FontMedium};
  color: ${COLORS.black};
`;

export const SectionDescription = styled.span`
  width: 350px;
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.lightSilver};

  @media only screen and ${BREAKPOINTS.desktop} {
    width: auto;
  }
`;

export const SectionTitle = styled.span`
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.lightSilver};
`;

export const SectionInput = styled.input`
  width: 350px;
  height: 46px;
  border-radius: 8px;
  background: ${COLORS.whiteLite};
  padding-left: 6px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 200px;
  }
`;

export const SectionButtonWrapper = styled.div`
  align-self: ${({ buttonWrapper }) => (buttonWrapper ? 'start' : 'unset')};
  display: flex;
  align-items: center;
  justify-content: end;
  flex-direction: column;
  width: 180px;
  margin-top: ${({ buttonWrapper }) => (buttonWrapper ? '46px' : '11px')};

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 120px;
  }
`;

export const SectionButton = styled.button`
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONTS.font16};
  width: 172px;
  height: 46px;
  border-radius: 8px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 120px;
    ${FONTS.font14};
  }
`;

export const PasswordWrapper = styled.div`
  display: flex;
  column-gap: 50px;
  row-gap: 10px;
  width: 770px;
  flex-wrap: wrap;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 480px;
    height: auto;
    flex-wrap: ${({ isPassword }) => (isPassword ? 'wrap' : 'unset')};
    justify-content: space-between;
  }
`;

export const AdminProfileAuth = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  height: auto;
  margin-top: 30px;
  border-bottom: 1px solid ${COLORS.whiteLite};

  @media only screen and ${BREAKPOINTS.desktop} {
    padding-bottom: 30px;
    align-items: start;
  }
`;

export const AboutAuthentication = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 688px;
  height: 100px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 480px;
    height: auto;
  }
`;

export const AuthenticationDescription = styled.span`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.lightSilver};
`;

export const EnableButton = styled.div`
  width: 172px;
  height: 46px;
  margin-left: 90px;

  @media only screen and ${BREAKPOINTS.desktop} {
    margin-left: unset;
    width: 120px;
  }
`;

export const AdminProfileSessionsAndDelete = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
`;

export const BrowserSession = styled.div`
  width: 100%;
  height: 160px;
  gap: 10px;
  display: flex;
  align-items: start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 34px;

  @media only screen and ${BREAKPOINTS.desktop} {
    height: auto;
  }
`;

export const BrowserSessionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ isLongText }) => (isLongText ? '14px' : 'unset')};
  width: ${({ isLongText }) => (isLongText ? '688px' : '350px')};
  height: ${({ isLongText }) => (isLongText ? 'auto' : '140')};

  @media only screen and ${BREAKPOINTS.desktop} {
    width: ${({ isLongText }) => (isLongText ? '480px' : '240px')};
  }
`;

export const BrowserSessionTitle = styled.span`
  ${FONTS.font18};
  ${FONT_FAMILY.FontMedium};
  color: ${COLORS.black};
`;

export const BrowserSessionDescription = styled.span`
  width: ${({ isLongText }) => (isLongText ? '100%' : '350px')};
  height: ${({ isLongText }) => (isLongText ? 'auto' : '42px')};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.lightSilver};

  @media only screen and ${BREAKPOINTS.desktop} {
    width: ${({ isLongText }) => (isLongText ? '480px' : '200px')};
  }
`;

export const DesktopSigns = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
  width: 100%;
  height: 40px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 400px;
    height: auto;
    gap: 10px;
    flex-wrap: wrap;
  }
`;

export const DesktopSign = styled.div`
  display: flex;
  gap: 14px;
  width: ${({ isLastActive }) => (isLastActive ? '300px' : '240px')};
  height: 30px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 200px;
    height: auto;
  }
`;

export const DesktopImage = styled.img``;

export const OperationNameAndIP = styled.span`
  width: ${({ isLastActive }) => (isLastActive ? '300px' : '196px')};
  display: flex;
  flex-direction: column;
`;

export const OperationName = styled.span`
  ${FONTS.font12};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.lightSilver};
`;

export const OperationDevice = styled.span`
  cursor: pointer;
  ${FONTS.font12};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.mainColor};
`;

export const LogOutOtherBrowsers = styled.button`
  justify-self: end;
  width: 264px;
  height: 46px;
  ${FONTS.font16};
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  border-radius: 8px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 160px;
    ${FONTS.font12};
  }
`;

export const DeleteAccount = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: 78px;
  height: auto;
  border-top: 1px solid ${COLORS.whiteLite};
  padding-top: 38px;
  padding-bottom: 38px;
`;

export const DeleteAccountButton = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.red};
  color: ${COLORS.white};
  ${FONTS.font16};
  border-radius: 8px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 120px;
    ${FONTS.font14};
  }
`;

export const DeleteAccountSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 708px;
  height: auto;
  margin-right: 74px;

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 460px;
  }
`;
export const DeleteAccountDescription = styled.span`
  width: ${({ isLongText }) => (isLongText ? '100%' : '350px')};
  height: ${({ isLongText }) => (isLongText ? 'auto' : '42px')};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.lightSilver};

  @media only screen and ${BREAKPOINTS.desktop} {
    width: 460px;
  }
`;

export const PasswordsLine = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
`;
